"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.barcodeTypes = exports.barcodeTypesValues = void 0;

var _types = require("../../../../types");

var _barcodeTypesValues;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var barcodeTypesValues = (_barcodeTypesValues = {}, _defineProperty(_barcodeTypesValues, _types.PkpassBarcodeTypes.PKBarcodeFormatAztec, {
  isSquared: true
}), _defineProperty(_barcodeTypesValues, _types.PkpassBarcodeTypes.PKBarcodeFormatPDF417, {
  isSquared: false
}), _defineProperty(_barcodeTypesValues, _types.PkpassBarcodeTypes.PKBarcodeFormatQR, {
  isSquared: true
}), _defineProperty(_barcodeTypesValues, _types.PkpassBarcodeTypes.PKBarcodeFormatCode128, {
  isSquared: false
}), _barcodeTypesValues);
exports.barcodeTypesValues = barcodeTypesValues;
var barcodeTypes = barcodeTypesValues;
exports.barcodeTypes = barcodeTypes;
//# sourceMappingURL=barcode.js.map